import { Injectable, signal } from '@angular/core';
import { ToastItem } from './model';
import { ToastVariant } from './type';

@Injectable({ providedIn: 'root' })
export class ToastService {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private readonly _toasts = signal<ToastItem[]>([]);
  readonly toasts = this._toasts.asReadonly();

  show(
    title: string,
    message: string,
    variant: ToastVariant = 'info',
    durationMs = 3500,
  ) {
    const id = crypto.randomUUID?.() ?? String(Date.now() + Math.random());

    const item: ToastItem = { id, title, message, variant, durationMs };
    this._toasts.update((items) => [item, ...items]);

    if (variant !== 'error' && durationMs > 0) {
      setTimeout(() => this.dismiss(id), durationMs);
    }

    return id;
  }

  dismiss(id: string) {
    this._toasts.update((items) => items.filter((x) => x.id !== id));
  }

  clear() {
    this._toasts.set([]);
  }
}
